import { CreateAdminActions } from ".";
import { CreateAdminConstants } from '.';

let initialState = {
  createAdminInProgress: false,
  user: [],
  storedUser: [],
  adminCreationError: undefined,
  existingAdmins: [],
  getExisingAdminsInProgress: false,
  getExistingAdminsError: false,
  createAdminFailed: false,
  deleteAdminInProgress: false,
  deleteAdminFailed: false
};

const createAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case CreateAdminConstants.CREATEADMIN_IN_PROGRESS:
      return { ...state, createAdminInProgress: true };
    case CreateAdminConstants.CREATEADMIN_COMPLETE:
      return { ...state, createAdminInProgress: false, data: action.data, createAdminFailed: false };
    case CreateAdminConstants.STORE_USER_COMPLETE:
      return { ...state, createAdminInProgress: false, storeUser: action.data };
    case CreateAdminConstants.CREATEADMIN_FAILURE:
      let newState = { ...state, createAdminInProgress: false, adminCreationError: action.data, createAdminFailed: true }
      return newState
    case CreateAdminConstants.GET_EXISTING_ADMIN_IN_PROGRESS:
      return {
        ...state, getExisingAdminsInProgress: true
      }


    case CreateAdminConstants.GET_EXISTING_ADMIN_SUCCESS:
      return {
        ...state,
        getExisingAdminsInProgress: false,
        getExistingAdminsError: false,
        existingAdmins: action.data.reverse()
      }


    case CreateAdminConstants.GET_EXISTING_ADMIN_FAILURE:
      return {
        ...state,
        getExistingAdminsError: true,
        getExisingAdminsInProgress: false
      }
    case CreateAdminConstants.DELETE_ADMIN_IN_PROGRESS:
      return { ...state, deleteAdminInProgress: true }
    case CreateAdminConstants.DELETE_ADMIN_SUCCESS:
      return { ...state, deleteAdminInProgress: false }
    case CreateAdminConstants.DELETE_ADMIN_FAILED:
      return { ...state, deleteAdminInProgress: false, deleteAdminFailed: true }
    default:
      return state;
  }
};

export default createAdminReducer;
